import SearchScenarioId from '../store/schema/SearchScenarioId';
import { action } from 'satcheljs';

/**
 * Action dispatched when the user clicks the arrow in command mode to execute
 * a command. Consuming client should set up an orchestrator to subscribe
 * to it and handle what should happen to execute the command.
 */
export const executeCommand = action('EXECUTE_COMMAND', (scenarioId: SearchScenarioId) => ({
    scenarioId,
}));
